export default __webpack_public_path__ + "bccd33c8b491a09405f39cbbd88e147c.gif";